var React = require('react');

function CommonIconArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-1430 -46)"},[React.createElement("path",{"d":"M0,0H24","transform":"translate(1430 49)","fill":"none","stroke":"#314a14","strokeWidth":"1","key":0}),React.createElement("path",{"d":"M3,0,6,8H0Z","transform":"translate(1462 46) rotate(90)","fill":"#314a14","key":1})]));
}

CommonIconArrow.defaultProps = {"width":"32","height":"6","viewBox":"0 0 32 6"};

module.exports = CommonIconArrow;

CommonIconArrow.default = CommonIconArrow;
